import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { SessionService } from 'src/app/store/session/session.service';
import { Observable } from 'rxjs';
import { SessionQuery } from 'src/app/store/session/session.query';
import { UserInfo } from 'src/app/store/session/session.store';
import { Router } from '@angular/router';


@Component({
  selector: 'app-header-sidebar',
  templateUrl: './header-sidebar.component.html',
  styleUrls: ['./header-sidebar.component.scss']
})
export class HeaderSidebarComponent implements OnInit {

  isAuthenticated$: Observable<boolean>;
  userInfo$: Observable<UserInfo>;

  notifications: any[];

  constructor(
    private navService: NavigationService,
    private sessionService: SessionService,
    private sessionQuery: SessionQuery,
    private router: Router
  ) {
    this.notifications = [
      {
        icon: 'i-Speach-Bubble-6',
        title: 'Lorem ipsum',
        text: 'Lorem ipsum',
        time: new Date(),
        status: 'primary'
      },
      {
        icon: 'i-Receipt-3',
        title: 'Lorem ipsum',
        text: 'Lorem ipsum',
        time: new Date('11/11/2018'),
        status: 'success'
      },
      {
        icon: 'i-Empty-Box',
        title: 'Lorem ipsum',
        text: 'Lorem ipsum',
        time: new Date('11/10/2018'),
        status: 'danger'
      }
    ];
  }

  ngOnInit() {
    this.isAuthenticated$ = this.sessionQuery.isAuthenticated$;
    this.userInfo$ = this.sessionQuery.userInfo$;
  }

  toggleSidebar() {
    const state = this.navService.sidebarState;
    if (state.childnavOpen) {
      return state.childnavOpen = false;
    }
    return state.childnavOpen = true;
  }

  signout() {
    this.sessionService.logout();

    this.router.navigate(['/login']);
  }

}
